var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-card", attrs: { id: "dashboard-card-programs" } },
    [
      _c("div", { staticClass: "dashboard-card-content" }, [
        _c(
          "div",
          { staticClass: "dashboard-card-title dashboard-typography" },
          [_vm._v(_vm._s(_vm.t("app-programs")))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "inquiries-breakdown" }, [
          _c("div", { staticClass: "inquiries-breakdown-option" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.programsInquiriesBreakdownOption,
                  expression: "programsInquiriesBreakdownOption",
                },
              ],
              attrs: {
                type: "radio",
                id: "programs-contacted-inquiries",
                name: "programs-inquiries",
                value: "contacted",
              },
              domProps: {
                checked: _vm._q(
                  _vm.programsInquiriesBreakdownOption,
                  "contacted"
                ),
              },
              on: {
                change: function ($event) {
                  _vm.programsInquiriesBreakdownOption = "contacted"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "programs-contacted-inquiries" } }, [
              _c(
                "span",
                {
                  staticClass:
                    "stat-count dashboard-typography dashboard-typography-vibrant",
                },
                [_vm._v(_vm._s(_vm.programsContactedInquiries))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label dashboard-typography" }, [
                _vm._v(_vm._s(_vm.t("app-contacted"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inquiries-breakdown-option" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.programsInquiriesBreakdownOption,
                  expression: "programsInquiriesBreakdownOption",
                },
              ],
              attrs: {
                type: "radio",
                id: "programs-uncontacted-inquiries",
                name: "programs-inquiries",
                value: "uncontacted",
              },
              domProps: {
                checked: _vm._q(
                  _vm.programsInquiriesBreakdownOption,
                  "uncontacted"
                ),
              },
              on: {
                change: function ($event) {
                  _vm.programsInquiriesBreakdownOption = "uncontacted"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "programs-uncontacted-inquiries" } }, [
              _c(
                "span",
                {
                  staticClass:
                    "stat-count dashboard-typography dashboard-typography-vibrant",
                },
                [_vm._v(_vm._s(_vm.programsUncontactedInquiries))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label dashboard-typography" }, [
                _vm._v(_vm._s(_vm.t("app-uncontacted"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inquiries-breakdown-option" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.programsInquiriesBreakdownOption,
                  expression: "programsInquiriesBreakdownOption",
                },
              ],
              attrs: {
                type: "radio",
                id: "programs-total-inquiries",
                name: "programs-inquiries",
                value: "total",
              },
              domProps: {
                checked: _vm._q(_vm.programsInquiriesBreakdownOption, "total"),
              },
              on: {
                change: function ($event) {
                  _vm.programsInquiriesBreakdownOption = "total"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "programs-total-inquiries" } }, [
              _c(
                "span",
                {
                  staticClass:
                    "stat-count dashboard-typography dashboard-typography-vibrant",
                },
                [_vm._v(_vm._s(_vm.programsTotalInquiries))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label dashboard-typography" }, [
                _vm._v(_vm._s(_vm.t("app-total"))),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "admin-list-table",
            class: _vm.programsInquiriesBreakdownOption,
          },
          [
            _c("vuetable", {
              attrs: {
                "api-mode": false,
                data: _vm.programsTableList,
                fields: _vm.programsTableFields,
                "show-sort-icons": false,
                "no-data-template": _vm.t("app-no-data-available"),
                css: { tableClass: "ui-table clickable-rows" },
              },
              on: { "vuetable:row-clicked": _vm.rowClicked },
              scopedSlots: _vm._u([
                {
                  key: "name-slot",
                  fn: function (props) {
                    return _c("div", {}, [
                      _c("div", {
                        staticClass: "table-legend",
                        style: `background: ${props.rowData.color}`,
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t(props.rowData.name)) +
                          "\n        "
                      ),
                    ])
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-card-actions" },
        [
          _c("DateRangeOptions", {
            ref: "dateRange",
            attrs: {
              "disabled-dates": "afterToday",
              limits: { min: null, max: _vm.tomorrowTs },
            },
            on: {
              input: _vm.onProgramsDateRangeInput,
              active: function ($event) {
                return _vm.$emit("onDateRangeActive", { uid: _vm._uid })
              },
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "dashboard-action-link",
              attrs: { to: _vm.link("admin/programs") },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.t("app-programs")) + "\n      "),
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("navigate_next"),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-wrapper" }, [
      _c("canvas", {
        attrs: { id: "programs-inquiries-chart", width: "400", height: "75" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }